const state = () => ({
  plans: []
});

const getters = {
  plans: state => {
    return state.plans;
  },
};

const actions = {
  async fetchPlans({ commit, rootState }, { groupId } = {}) {
    const { data } = await this.$http.get(`/tenants/${rootState.tenant.tenant.id}/plan-showcase`, {
      params: {
        groupId,
      },
    });
    commit("setPlans", data);
  },
  async addPlan({ commit, rootState }, { id, descriptions }) {
    const { data } = await this.$http.post(`/tenants/${rootState.tenant.tenant.id}/plan-showcase`, { planId: id, descriptions });
    commit("pushPlan", data);
  },
  async updatePlan({ commit, rootState }, { id, recommended, internal }) {
    const { data } = await this.$http.patch(`/tenants/${rootState.tenant.tenant.id}/plan-showcase/${id}`, { recommended, internal });
    commit("refreshPlan", data);
  },
  async deletePlan({ commit, rootState }, { id }) {
    await this.$http.delete(`/tenants/${rootState.tenant.tenant.id}/plan-showcase/${id}`);
    commit("removePlan", id);
  },
};

const mutations = {
  setPlans(state, data) {
    state.plans = data;
  },
  pushPlan(state, data) {
    state.plans.push(data);
  },
  refreshPlan(state, data) {
    const plan = state.plans.find(p => p.id == data.id);
    plan.recommended = data.recommended;
    plan.internal = data.internal;
    state.plans = [...state.plans.map(item => item.id !== data.id ? item : {...item, ...plan})]
  },
  removePlan(state, id) {
    state.plans = state.plans.filter(p => p.id != id);
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
